import { Service } from '@angular/core';
import type { OnyxAmount } from '@onyx/angular';
import type { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Service()
export class AmountService extends ApiService {
  public calculateAmount(
    amount: Pick<OnyxAmount, 'date' | 'value' | 'currency' | 'resultCurrency'>,
  ): Observable<Required<OnyxAmount>> {
    return this.post(`/amount`, amount);
  }
}
